import { registerChunkErrorReload } from './utils/chunkErrorReload'

registerChunkErrorReload()

import('./bootstrap')
